// Mock data for Trademark Registration Website

export const mockData = {
  contact: {
    email: 'info@trademarkmybrandname.com',
    phone: '+1 (123) 123-4567',
    address: '15233 Ventura Blvd, Sherman Oaks, CA 91403'
  },
  
  hero: {
    title: 'Protect Your Brand with Professional Trademark Registration',
    subtitle: 'Secure your brand identity with expert USPTO trademark filing services. Fast, reliable, and affordable trademark protection for businesses across the United States.',
    cta: 'Register My Trademark',
    image: 'https://images.unsplash.com/photo-1758519288480-1489c17b1519'
  },

  about: {
    title: 'Your Trusted Partner in Trademark Protection',
    description: 'We specialize exclusively in trademark registration services. With years of experience navigating the USPTO filing process, we help businesses secure their brand identity and protect their intellectual property.',
    stats: [
      { number: '1000+', label: 'Trademarks Filed' },
      { number: '98%', label: 'Success Rate' },
      { number: '15+', label: 'Years Experience' },
      { number: '24/7', label: 'Support Available' }
    ]
  },

  services: [
    {
      title: 'Comprehensive Trademark Search',
      description: 'Thorough examination of USPTO database and common law sources to identify potential conflicts before filing.',
      icon: 'Search',
      details: 'Our comprehensive search includes federal, state, and common law trademark databases to uncover potential conflicts and assess registration likelihood.'
    },
    {
      title: 'USPTO Filing & Registration',
      description: 'Expert preparation and filing of your trademark application, ensuring all requirements are met.',
      icon: 'FileText',
      details: 'We handle all aspects of the filing process, from selecting proper classifications to crafting precise descriptions of goods and services.'
    },
    {
      title: 'Office Action Response',
      description: 'Professional handling of USPTO office actions with strategic responses to overcome refusals.',
      icon: 'MessageSquare',
      details: 'Our experienced team prepares persuasive legal arguments and evidence to address examiner objections and move your application forward.'
    },
    {
      title: 'Trademark Monitoring',
      description: 'Continuous monitoring of new applications to identify potential infringements.',
      icon: 'Shield',
      details: 'We actively monitor the USPTO database for confusingly similar marks and notify you of potential threats to your brand.'
    },
    {
      title: 'Brand Protection Strategy',
      description: 'Comprehensive trademark portfolio management and enforcement strategies.',
      icon: 'Lock',
      details: 'Strategic planning for building and protecting your trademark portfolio, including multi-class filings and international considerations.'
    },
    {
      title: 'Renewal Services',
      description: 'Timely trademark renewal filings to maintain continuous brand protection.',
      icon: 'RefreshCw',
      details: 'We track all deadlines and file required maintenance documents including Declarations of Use and renewal applications.'
    },
    {
      title: 'Trademark Clearance Analysis',
      description: 'In-depth legal analysis of your trademark\'s registrability and potential risks.',
      icon: 'CheckCircle',
      details: 'Detailed legal opinion on the strength of your mark, likelihood of registration, and potential infringement risks.'
    },
    {
      title: 'Intent-to-Use Applications',
      description: 'File before you launch with Intent-to-Use applications to secure priority.',
      icon: 'Zap',
      details: 'Protect your brand before market launch by reserving your trademark rights through ITU applications.'
    },
    {
      title: 'Trademark Portfolio Management',
      description: 'Manage multiple trademarks across different classes and jurisdictions.',
      icon: 'Layers',
      details: 'Centralized management of your trademark assets with deadline tracking and strategic portfolio optimization.'
    },
    {
      title: 'Opposition & Cancellation',
      description: 'Defend your trademark rights or challenge conflicting marks.',
      icon: 'Scale',
      details: 'Expert representation in TTAB proceedings for opposition and cancellation matters.'
    },
    {
      title: 'Cease & Desist Letters',
      description: 'Professional enforcement letters to stop trademark infringement.',
      icon: 'AlertTriangle',
      details: 'Strategically crafted demand letters to protect your rights and resolve infringement disputes.'
    },
    {
      title: 'Trademark Assignment & Licensing',
      description: 'Handle ownership transfers and licensing agreements.',
      icon: 'FileSignature',
      details: 'Complete documentation and USPTO recordation of trademark assignments and license agreements.'
    }
  ],

  whyChooseUs: [
    {
      title: 'USPTO Filing Experts',
      description: 'Specialized knowledge of trademark law and USPTO procedures ensures accurate applications.',
      icon: 'Award'
    },
    {
      title: 'Transparent Pricing',
      description: 'Clear, upfront pricing with no hidden fees. Know exactly what you\'re paying for.',
      icon: 'DollarSign'
    },
    {
      title: 'Dedicated Support',
      description: 'Personal case manager providing updates throughout the entire process.',
      icon: 'Users'
    },
    {
      title: 'Fast Turnaround',
      description: 'Quick application preparation and filing to start your protection without delay.',
      icon: 'Zap'
    }
  ],

  process: [
    {
      step: '01',
      title: 'Consultation & Search',
      description: 'We start with a free consultation to understand your needs, followed by a comprehensive trademark search to identify potential conflicts and assess the registrability of your mark.'
    },
    {
      step: '02',
      title: 'Application Preparation & USPTO Filing',
      description: 'Our experts prepare your trademark application with proper classifications and descriptions, then file it electronically with the USPTO. You\'ll receive your filing receipt and serial number immediately.'
    },
    {
      step: '03',
      title: 'Monitoring & Registration',
      description: 'We monitor your application status, handle any office actions from USPTO examining attorneys, and guide you through to final registration. Once approved, we provide ongoing monitoring and renewal services.'
    }
  ],

  pricing: [
    {
      name: 'Essentials',
      price: '$45',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Basic Search',
        'State E-Filing',
        'Trademark Secured'
      ],
      note: '(Govt. filing fee not included)',
      popular: false
    },
    {
      name: 'Enhanced',
      price: '$149',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter'
      ],
      note: '(Govt. filing fee not included)',
      popular: false
    },
    {
      name: 'Deluxe',
      price: '$299',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager'
      ],
      note: '(Govt. filing fee not included)',
      popular: true,
      recommended: true
    },
    {
      name: 'Platinum',
      price: '$349',
      subtitle: '+ Federal Filing Fee',
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured',
        'High Satisfaction Rate',
        'Refusal Risk Meter',
        'Trademark Monitoring',
        'Complete Documentation',
        'Digital File',
        'Dedicated Case Manager',
        'High Approval Rate',
        'Comprehensive Search Report',
        'High Priority Service',
        'Cease & Desist Letter'
      ],
      note: '(Govt. filing fee not included)',
      popular: false
    }
  ],

  industries: [
    { name: 'Technology & Software', icon: 'Laptop', description: 'SaaS, apps, tech startups' },
    { name: 'Retail & E-commerce', icon: 'ShoppingCart', description: 'Online stores, retail brands' },
    { name: 'Food & Beverage', icon: 'Coffee', description: 'Restaurants, food brands' },
    { name: 'Healthcare & Medical', icon: 'Heart', description: 'Medical services, devices' },
    { name: 'Fashion & Apparel', icon: 'Shirt', description: 'Clothing, accessories' },
    { name: 'Professional Services', icon: 'Briefcase', description: 'Consulting, legal, finance' },
    { name: 'Manufacturing', icon: 'Factory', description: 'Industrial, products' },
    { name: 'Entertainment & Media', icon: 'Film', description: 'Content, production' },
    { name: 'Beauty & Cosmetics', icon: 'Sparkles', description: 'Skincare, makeup brands' },
    { name: 'Fitness & Wellness', icon: 'Dumbbell', description: 'Gyms, health products' },
    { name: 'Education & Training', icon: 'GraduationCap', description: 'Schools, online courses' },
    { name: 'Real Estate', icon: 'Home', description: 'Property, construction' },
    { name: 'Automotive', icon: 'Car', description: 'Vehicles, auto services' },
    { name: 'Financial Services', icon: 'DollarSign', description: 'Banking, fintech, insurance' },
    { name: 'Hospitality & Tourism', icon: 'Plane', description: 'Hotels, travel services' },
    { name: 'Agriculture & Farming', icon: 'Leaf', description: 'Organic, farm products' },
    { name: 'Sports & Recreation', icon: 'Trophy', description: 'Athletic brands, equipment' },
    { name: 'Gaming & Esports', icon: 'Gamepad2', description: 'Video games, tournaments' },
    { name: 'Pet Care & Services', icon: 'PawPrint', description: 'Pet products, veterinary' },
    { name: 'Environmental & Green', icon: 'Recycle', description: 'Sustainable brands' }
  ],

  benefits: [
    {
      title: 'Exclusive Nationwide Rights',
      description: 'Federal registration grants exclusive nationwide rights to use your mark in connection with your goods or services.',
      icon: 'Crown',
      details: 'Unlike state or common law rights limited to geographic areas, federal registration provides exclusive rights across all 50 states.'
    },
    {
      title: 'Legal Presumption of Ownership',
      description: 'Provides legal presumption of ownership and right to sue in federal court for infringement.',
      icon: 'Scale',
      details: 'Registration creates a legal presumption of validity and ownership, making enforcement significantly easier and more powerful.'
    },
    {
      title: 'Increased Brand Value',
      description: 'A valuable business asset that increases company worth and can be licensed or sold.',
      icon: 'TrendingUp',
      details: 'Registered trademarks are tangible assets on your balance sheet, increasing valuation for investors and potential buyers.'
    },
    {
      title: 'Deterrent Effect',
      description: 'The ® symbol warns competitors and prevents similar registrations, protecting your market position.',
      icon: 'AlertTriangle',
      details: 'The registered trademark symbol serves as a powerful deterrent, reducing infringement and copycat attempts.'
    },
    {
      title: 'U.S. Customs Protection',
      description: 'Allows U.S. Customs and Border Protection to block importation of infringing counterfeit goods.',
      icon: 'Globe',
      details: 'Record your trademark with Customs to prevent counterfeit products from entering the United States.'
    },
    {
      title: 'Online Marketplace Protection',
      description: 'Strengthens enforcement on Amazon, eBay, social media platforms, and domain disputes.',
      icon: 'Monitor',
      details: 'Most platforms require federal registration for brand registry programs and accelerated takedown procedures.'
    },
    {
      title: 'Priority Filing Date',
      description: 'Establishes your priority date nationwide, preventing others from claiming rights to similar marks.',
      icon: 'Calendar',
      details: 'Your filing date becomes your nationwide priority date, crucial in disputes over who has superior rights.'
    },
    {
      title: 'Statutory Damages & Attorney Fees',
      description: 'Eligible for enhanced damages and recovery of legal fees in infringement lawsuits.',
      icon: 'Gavel',
      details: 'Registration allows you to seek statutory damages and attorney fees, making litigation more economically viable.'
    },
    {
      title: 'International Protection Basis',
      description: 'Required for international trademark registration through the Madrid Protocol.',
      icon: 'MapPin',
      details: 'U.S. registration serves as the foundation for protecting your brand in over 120 countries worldwide.'
    },
    {
      title: 'Constructive Notice',
      description: 'Provides constructive nationwide notice of your claim, preventing good faith defenses.',
      icon: 'Bell',
      details: 'Once registered, others cannot claim they were unaware of your trademark rights anywhere in the U.S.'
    },
    {
      title: 'Incontestable Status',
      description: 'After 5 years, your mark can become incontestable, providing nearly unassailable rights.',
      icon: 'ShieldCheck',
      details: 'Incontestable status significantly limits challenges to your trademark and strengthens enforcement.'
    },
    {
      title: 'Corporate Value & Investment',
      description: 'Essential for attracting investors, securing loans, and demonstrating business legitimacy.',
      icon: 'Briefcase',
      details: 'Investors and lenders view registered trademarks as indicators of a serious, protected business with valuable IP assets.'
    }
  ],

  trustSignals: [
    {
      title: 'USPTO Registered Agents',
      description: 'Our team includes USPTO-registered trademark attorneys and agents.',
      icon: 'CheckCircle'
    },
    {
      title: '1000+ Successful Filings',
      description: 'We\'ve successfully filed and registered over 1,000 trademarks for clients nationwide.',
      icon: 'Award'
    },
    {
      title: '98% Approval Rate',
      description: 'Our comprehensive search and expert filing process results in a 98% approval rate.',
      icon: 'TrendingUp'
    },
    {
      title: 'A+ BBB Rating',
      description: 'Accredited business with an A+ rating from the Better Business Bureau.',
      icon: 'Star'
    }
  ],

  faqs: [
    {
      question: 'What is a trademark and why do I need one?',
      answer: 'A trademark is a word, phrase, symbol, or design that identifies and distinguishes your goods or services from others. Federal trademark registration provides exclusive nationwide rights, legal protection, and the ability to prevent others from using confusingly similar marks. It\'s essential for protecting your brand identity and building brand value.'
    },
    {
      question: 'How long does the trademark registration process take?',
      answer: 'The entire USPTO trademark registration process typically takes 8-12 months from filing to registration. After filing, you\'ll receive a serial number immediately. The USPTO examining attorney will review your application within 3-4 months. If approved, your mark will be published for opposition for 30 days, then registered if no opposition is filed.'
    },
    {
      question: 'What are the costs involved in trademark registration?',
      answer: 'The total cost includes our service fee (starting at $45 depending on the package) plus the USPTO government filing fee (currently $250-$350 per class). Our transparent pricing means no hidden fees. The government fee is paid directly to the USPTO and varies based on the filing basis and number of classes.'
    },
    {
      question: 'Can I trademark a business name or logo?',
      answer: 'Yes, you can trademark both business names and logos. A word mark protects the text of your brand name, while a design mark protects logos and stylized designs. Many businesses register both to ensure comprehensive protection. We can help you determine the best filing strategy for your specific needs.'
    },
    {
      question: 'What is a trademark search and why is it important?',
      answer: 'A trademark search examines existing federal and state registrations, pending applications, and common law uses to identify potential conflicts. This crucial step helps avoid costly rejections and legal disputes. Our comprehensive search includes USPTO database searches, internet searches, and analysis of similar marks to assess registration likelihood.'
    },
    {
      question: 'What happens if my trademark application is refused?',
      answer: 'If the USPTO refuses your application, we\'ll handle the response. Common refusal reasons include likelihood of confusion with existing marks or descriptiveness issues. Our experienced team prepares persuasive legal arguments and evidence to overcome refusals. Our Enhanced, Deluxe, and Platinum packages include office action response services.'
    },
    {
      question: 'How long does trademark protection last?',
      answer: 'Once registered, your trademark protection lasts 10 years and can be renewed indefinitely as long as you continue using the mark in commerce. You must file a Declaration of Use between years 5-6 and renew every 10 years. We provide renewal reminder services to ensure you never lose your trademark rights.'
    },
    {
      question: 'Can I use the ® symbol before my trademark is registered?',
      answer: 'No, the ® symbol can only be used after your trademark is officially registered with the USPTO. Before registration, you can use ™ for goods or ℠ for services to indicate you\'re claiming trademark rights. Using ® before registration is illegal and can result in your application being denied or registration being cancelled.'
    }
  ],

  testimonials: [
    {
      name: 'Sarah Mitchell',
      company: 'Tech Startup Founder',
      text: 'The team made trademark registration incredibly easy. They handled everything professionally and kept me informed throughout the process. My brand is now fully protected!',
      rating: 5
    },
    {
      name: 'James Rodriguez',
      company: 'Restaurant Owner',
      text: 'After trying to file myself and getting confused, I hired Trademark My Brand Name. Best decision ever! They fixed my application and got it approved within months.',
      rating: 5
    },
    {
      name: 'Emily Chen',
      company: 'E-commerce Business',
      text: 'Outstanding service! The comprehensive search they conducted saved me from a potential legal issue. Their expertise is worth every penny.',
      rating: 5
    }
  ]
};

export const countryCodes = [
  { code: '+1', country: 'United States' },
  { code: '+1', country: 'Canada' },
  { code: '+44', country: 'United Kingdom' },
  { code: '+91', country: 'India' },
  { code: '+61', country: 'Australia' },
  { code: '+86', country: 'China' },
  { code: '+81', country: 'Japan' },
  { code: '+49', country: 'Germany' },
  { code: '+33', country: 'France' },
  { code: '+39', country: 'Italy' }
];
